import {
	CheckCircle,
	Plus,
	UserPlus02,
	UserX02,
	XCircle,
} from "@untitledui/icons";
import type { ComponentType } from "react";

export const INFRACTION_HISTORY_EVENT_TYPE = {
	AUTOMATED_CREATED: 1,
	MANUAL_CREATED: 2,
	DRIVER_ASSIGNED: 3,
	DRIVER_INDICATION_EXPIRED: 4,
	PAID: 5,
	PAYMENT_EXPIRED: 6,
} as const;

export const INFRACTION_HISTORY_ACTOR_TYPE = {
	SYSTEM: 1,
	USER: 2,
} as const;

export type InfractionHistoryEventStyle = {
	root: string;
	icon: string;
	Icon: ComponentType<{ className?: string }>;
};

export const INFRACTION_HISTORY_EVENT_STYLES: Record<
	number,
	InfractionHistoryEventStyle
> = {
	[INFRACTION_HISTORY_EVENT_TYPE.AUTOMATED_CREATED]: {
		root: "bg-bg-brand-solid",
		icon: "text-fg-white",
		Icon: Plus,
	},
	[INFRACTION_HISTORY_EVENT_TYPE.MANUAL_CREATED]: {
		root: "bg-bg-brand-solid",
		icon: "text-fg-white",
		Icon: Plus,
	},
	[INFRACTION_HISTORY_EVENT_TYPE.DRIVER_ASSIGNED]: {
		root: "bg-bg-brand-secondary",
		icon: "text-fg-brand-primary",
		Icon: UserPlus02,
	},
	[INFRACTION_HISTORY_EVENT_TYPE.DRIVER_INDICATION_EXPIRED]: {
		root: "bg-bg-error-primary",
		icon: "text-fg-error-primary",
		Icon: UserX02,
	},
	[INFRACTION_HISTORY_EVENT_TYPE.PAID]: {
		root: "bg-bg-success-primary",
		icon: "text-success-primary",
		Icon: CheckCircle,
	},
	[INFRACTION_HISTORY_EVENT_TYPE.PAYMENT_EXPIRED]: {
		root: "bg-bg-error-primary",
		icon: "text-fg-error-primary",
		Icon: XCircle,
	},
};

export const DEFAULT_INFRACTION_HISTORY_EVENT_STYLE: InfractionHistoryEventStyle =
	{
		root: "bg-bg-brand-solid",
		icon: "text-fg-white",
		Icon: Plus,
	};
